/**
 * Created by admin on 2017/3/24.
 */
import {
    PackageByPage,
    GetPackageExport,
    PackageDel
} from '../../api/packageApi.js'
import {
    GetProductAttribute
} from '../../api/commonApi.js'
import {
    ProductUnEnable
} from '../../api/productApi.js'
import NProgress from 'nprogress'
import {
    util
} from '../../common/js/util.js';
module.exports = {
    data() {
        return {
            Session: util.getSessin(),
            loading2: false,
            pageIndex: 1,
            pageSize: 10,
            sels: [],
            totalSize: '',
            pageSizes: [10, 20, 50],
            List: [],
            Attribute: [],
            query: {
                ProCode: "",
                ProName: "",
                ProAttribute: ""
            },
        }
    },

    methods: {
        download: function() {
            this.$confirm('确认导出吗？', '提示', {}).then(() => {
                var ids = this.sels.map(item => item.ProductId).toString();
                if (ids == "") {
                    this.getList();
                    var Params = {
                        Sid: this.Session[0],
                        Session: this.Session[1]
                    };
                    if (this.query.ProCode != "") {
                        Params.ProCode = this.query.ProCode;
                    }
                    if (this.query.ProName != "") {
                        Params.ProName = this.query.ProName;
                    }
                    if (this.query.ProAttribute != "" && this.query.ProAttribute != "All") {
                        Params.ProAttribute = this.query.ProAttribute;
                    }
                } else {
                    var Params = {
                        Sid: this.Session[0],
                        Session: this.Session[1]
                    };
                    Params.ids = ids;
                }
                GetPackageExport(Params).then(res => {
                    let {
                        StateCode,
                        StateMsg,
                        Data,
                        Cnt
                    } = res.data;
                    util.doResult(this, res, () => {
                        try {

                            var elemIF = document.createElement("iframe");
                            elemIF.src = Data;
                            elemIF.style.display = "none";
                            document.body.appendChild(elemIF);
                        } catch (e) {
                            this.$notify({
                                title: '浏览器不兼容，建议使用谷歌浏览器',
                                type: 'error'
                            });
                        }
                    })
                })
            })
        },
        getList() {
            this.List = [];
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1],
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            };
            if (this.query.ProCode != "") {
                Params.ProCode = this.query.ProCode;
            }
            if (this.query.ProName != "") {
                Params.ProName = this.query.ProName;
            }
            if (this.query.ProAttribute != "" && this.query.ProAttribute != "All") {
                Params.ProAtti = this.query.ProAttribute;
            }
            this.loading2 = true;
            PackageByPage(Params).then(res => {
                util.doResult(this, res, () => {
                    this.totalSize = res.data.Cnt;
                    this.List = res.data.Data;
                    this.loading2 = false;

                })
            })
        },
        forbidden: function(index, row) {
            this.$confirm('确认禁用吗？', '提示', {}).then(() => {
                /* var ids = this.sels.map(item => item.ProductId).toString();*/
                var ids = row.ProductId;
                var Params = {
                    Ids: ids
                };
                ProductUnEnable(Params).then(res => {
                    let {
                        StateCode,
                        StateMsg,
                        Data,
                        Cnt
                    } = res.data;
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: "禁用成功",
                            type: 'success'
                        });
                        this.getList()
                    })
                })
            })
        },
        getAttr() {
            this.Attribute = [{
                Key: "全部",
                Value: "All"
            }];
            var Params = {
                Sid: this.Session[0],
                Session: this.Session[1]
            };
            GetProductAttribute(Params).then(res => {
                util.doResult(this, res, () => {});
                if (res.data.StateCode !== 0) {
                    if (res.data.StateCode == 99) {
                        this.$router.push('/login')
                    } else {
                        this.$notify({
                            title: '错误',
                            message: res.data.StateMsg,
                            type: 'error'
                        });
                    }
                } else {
                    for (var i = 0; i < res.data.Data.length; i++) {
                        this.Attribute.push(res.data.Data[i])
                    }
                }
            })
        },
        addPackage: function() {
            util.redirect(this, '/productInformation/productControl/addPackage', true);
        },
        handleEdit(index, item) {
            util.redirect(this, '/productInformation/productControl/addPackage?Id=' + item.ProductId, true);
        },
        ViewPackage(index, item) {
            util.redirect(this, '/productInformation/productControl/addPackage?Id=' + item.ProductId + "&view=1", true);
        },
        handleDel(index, item) {
            this.$confirm('确认删除吗？', '提示', {}).then(() => {
                /* var ids = this.sels.map(item => item.ProductId).toString();*/
                var ids = item.ProductId;
                var Params = {
                    Ids: ids
                };
                PackageDel(Params).then(res => {
                    let {
                        StateCode,
                        StateMsg,
                        Data,
                        Cnt
                    } = res.data;
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: "删除成功",
                            type: 'success'
                        });
                        this.getList()
                    })
                })
            })
        },
        selsChange: function(sels) {
            this.sels = sels;
        },
        handleSizeChange: function(val) {
            this.pageSize = val;
        },
        handleCurrentChange: function(val) {
            this.pageIndex = val;
            this.getList();
        }
    },
    watch: {
        $route: function() {
            if (this.$route.name == '套餐管理') {
                this.getList();
            }
        }
    },
    created() {
        this.getList();
        this.getAttr();
    },


}


// WEBPACK FOOTER //
// ./src/pages/productInformation/packageControl.js